/**
 * Created by danial.bagheri on 08/02/17.
 */
const kulzerConfig = {
};

module.exports = {};

if ( 'production' === process.env.NODE_ENV ) {
    if ( 'licensing' === process.env.PRODUCT ) {
        module.exports = kulzerConfig;
    }
}



// WEBPACK FOOTER //
// ./app/config.js